const JsGuideDisplay = {
	init () {

		/*
		 * Guide display - Hompage
		*/

		// var $arrow = $('..nav-arrow:after'),
		// moving variables to top to avoid any potential hoisting problems
		var $boxes = $('.boxlink');
		var $scrollTo = $('.js-scroll-to');
		var $arrowBox = $('.blank-arrow-box');
		var $sp1 = $('#f-speech-deer');
		var $sp2 = $('#f-speech-fox');
		var $sp3 = $('#f-speech-tit');
		var $sp4 = $('#f-speech-squirrel');

		/**
		* Handle any fancy scrolls
		* It'll offset by the height of the header
		*/
		$scrollTo.on('click', function () {
			var $target = $($(this).attr('href'));
			var headerHeight = $('.c-header').height();

			if ($target.length) {
				$('html, body').animate({
					scrollTop: $target.offset().top - headerHeight
				}, '500');
			}
		});

		if ($sp1||$sp2||$sp3||$sp4.is(':visible')) {
		//
		} else {
			$arrowBox.is(':visible');
		}

		$('a').on({
			'mouseenter':function(){
				$('#'+$(this).data('id')).fadeIn('fast');
				$('.'+$(this).data('id')).is(':hidden');
			},'mouseleave':function(){
				$('#'+$(this).data('id')).fadeOut('fast');
				$('.'+$(this).data('id')).is(':visible');
			}
		});

	}
};

export default JsGuideDisplay;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/guide-display.js